<script>
	let { class: className = '', ...props } = $props();
</script>

<svg class={className} fill="none" preserveAspectRatio="none" viewBox="0 0 44 36" {...props}>
	<path
		d="M6.281 31.154V2.077h25.842V9M9.719 7.615h6.4M9.719 27h6.4m-6.4-13.846h14.026M9.719 16.615H20.95M9.719 20.077h4.946m7.695-.964L38.495 2.606l2.933 3.002-16.135 16.506m-2.939-3.001-1.956 4.001.978 1 3.913-2M36.54 4.607l4.4 4.502m.002 0-5.38 5.502m-15.158 9.504-1.466 1.5M39.477 2.607l1.466-1.501a1.36 1.36 0 0 1 1.956 0c.54.552.54 1.449 0 2l-1.467 1.501m-12.102 30.7H3.49c-1.544 0-2.794-1.239-2.794-2.769v-1.384h25.842v1.384c0 1.53 1.25 2.77 2.793 2.77m0 0c1.544 0 2.794-1.239 2.794-2.769V19.384"
		stroke="currentColor"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="1"
	/>
</svg>
